// extracted by mini-css-extract-plugin
module.exports = {"admin":"styles_admin__1n8OJ"};